export enum ETrackingEvent {
  SIGN_UP_RADIO_SELECT_USER_TYPE = 'sign_up_radio_select_user_type',
  SIGN_UP_BTN_NEXT = 'sign_up_btn_next',
  SIGN_UP_INPUT_CODE = 'sign_up_input_code',
  SIGN_UP_BTN_GET_CODE = 'sign_up_btn_get_code',

  INPUT_EMAIL = 'input_email',
  INPUT_SIGN_IN_PSWD = 'input_password',
  ERROR_EMAIL_DOMAIN = 'error_email_domain',
  ERROR_PSWD_BAD = 'error_pswd_bad',
  BTN_SIGNIN = 'btn_signin',
  BTN_FORGOT_PSWD = 'btn_forgot_pswd',
  BTN_SIGNUP = 'btn_signup',
  BTN_ADD_YOUR_JOB = 'btn_add_your_job',
  INPUT_NAME = 'input_name',
  INPUT_WORK_EMAIL = 'input_work_email',

  BTN_DASHBOARD_VIEW_MESSAGES = 'btn_dashboard_view_messages',
  BTN_DASHBOARD_VIEW_MATCHES = 'btn_dashboard_view_matches',
  BTN_CONNECTION_TAB_MATCHES = 'btn_connection_tab_matches',
  BTN_CONNECTION_TAB_LIKED_MY_VIBE = 'btn_connection_tab_liked_my_vibe',
  BTN_CONNECTION_TAB_PEOPLE_I_LIKED = 'btn_connection_tab_people_i_liked',
  BTN_DASHBOARD_VIEW_LIKED_MY_VIBE = 'btn_dashboard_view_liked_my_vibe',
  BTN_DASHBOARD_VIEW_PEOPLE_I_LIKED = 'btn_dashboard_view_people_i_liked',
  BTN_CARD_TALENT_DETAILS = 'btn_card_talent_details',
  BTN_CARD_TALENT_UNMATCH = 'btn_card_talent_unmatch',
  BTN_CARD_TALENT_LIKE = 'btn_card_talent_like',
  BTN_CARD_TALENT_MESSAGE = 'btn_card_talent_message',
  BTN_TOGGLE_MESSAGE_ASIDE = 'btn_toggle_message_aside',
  BTN_MESSAGE_MENU = 'btn_message_menu',
  BTN_MESSAGE_UNMATCH = 'btn_message_unmatch',
  BTN_MESSAGE_REPORT = 'btn_message_report',

  BTN_TALENT_TAB_MATCH_DETAIL = 'btn_talent_tab_match_detail',
  BTN_TALENT_TAB_MATCH_MESSAGE = 'btn_talent_tab_match_message',

  BTN_CONFIRM_INVITE = 'btn_confirm_invite',

  SELECT_MESSAGE_REPORT_REASON = 'select_message_report_reason',
  INPUT_MESSAGE_REPORT_DETAILS = 'input_message_report_details',
  BTN_MESSAGE_SUBMIT_REPORT = 'btn_message_submit_report',
  BTN_MESSAGE_CANCEL_REPORT = 'btn_message_cancel_report',

  BTN_RESEND_VERIFY_EMAIL = 'btn_resend_verify_email',
  BTN_RESEND_EMAIL = 'btn_resend_email',
  BTN_PSWD_SETUP = 'btn_pswd_setup',
  INPUT_PASSWORD = 'input_password',
  INPUT_CONFIRM_PASSWORD = 'input_confirm_password',
  INPUT_COMPANY_NAME = 'input_company_name',
  BTN_PSWD_NEXT = 'btn_pswd_next',
  CHKBOX_ROLES = 'chkbox_roles',
  INPUT_ROLES_COMMENT = 'input_roles_comment',
  BTN_ROLES_NEXT = 'btn_roles_next',
  INPUT_FIRST_NAME = 'input_first_name',
  INPUT_LAST_NAME = 'input_last_name',
  INPUT_COMPANY = 'input_company',
  INPUT_COMPANY_URL = 'input_company_url',
  CHKBOX_SPAM = 'chkbox_spam',
  BTN_INFO_NEXT = 'btn_info_next',

  INPUT_PSWD_CODE = 'input_pswd_code',
  INPUT_PSWD_NEW = 'input_pswd_new',
  /**
   * @deprecated
   */
  BTN_SEND_RESET_PSWD_LINK = 'btn_send_reset_pswd_link',
  BTN_RESET_PSWD_GET_CODE = 'btn_reset_pswd_get_code',
  /**
   * @deprecated
   */
  BTN_RESEND_RESET_PSWD_LINK = 'btn_resend_reset_pswd_link',
  BTN_RESET_PSWD = 'btn_reset_pswd',
  BTN_SETTING_RESET_PASSWORD = 'btn_setting_reset_password',
  BTN_CHANGE_PSWD = 'btn_change_pswd',

  BTN_FLAG = 'btn_flag',
  BTN_INTRODUCE = 'btn_introduce',

  BTN_VIDEO_SKIP = 'btn_video_skip',
  BTN_VIDEO_TRASH = 'btn_video_trash',
  BTN_VIDEO_SUPERLIKE = 'btn_video_superlike',
  BTN_VIDEO_LIKE = 'btn_video_like',
  BTN_VIDEO_INVITE_APPLY = 'btn_video_invite_apply',

  BTN_VIBES_SCREEN = 'btn_vibes_screen',
  BTN_LIKES_SCREEN = 'btn_likes_screen',
  BTN_INTROS_SCREEN = 'btn_intros_screen',
  BTN_SKIPS_SCREEN = 'btn_skips_screen',
  BTN_SKIP_STEP_CLAIM_JOB = 'btn_skip_step_claim_job',
  BTN_CAMPAIGN_SCREEN = 'btn_campaign_screen',
  BTN_MY_JOBS_SCREEN = 'btn_my_jobs',
  BTN_NAV_PROFILE = 'btn_nav_profile',
  BTN_OPTIONS_PROFILE = 'btn_options_profile',
  BTN_OPTIONS_PAYMENTS = 'btn_options_payments',
  BTN_OPTIONS_INVITE = 'btn_options_invite',
  BTN_OPTIONS_SIGNOUT = 'btn_options_signout',
  BTN_EDIT_PROFILE = 'btn_edit_profile',
  BTN_STORE = 'btn_store',
  BTN_NAV_HELP = 'btn_nav_help',
  SELECT_ROLE = 'select_role',

  BTN_STEP1 = 'btn_step1',
  BTN_STEP2 = 'btn_step3',
  BTN_STEP3 = 'btn_step2',
  BTN_STEP4 = 'btn_step4',
  BTN_STEP_HIDE = 'btn_step_hide',

  BTN_VIDEO_SHARE = 'btn_video_share',
  INPUT_SHARE_EMAIL = 'input_share_email',
  INPUT_SHARE_COMMENT = 'input_share_comment',

  BTN_CREATE_ACCOUNT = 'btn_create_account',
  INPUT_CANDIDATE_COMMENT = 'input_candidate_comment',
  BTN_CANDIDATE_LIKE = 'btn_candidate_like',
  BTN_CANDIDATE_DISLIKE = 'btn_candidate_dislike',
  BTN_COMMENT_SEND = 'btn_comment_send',
  BTN_INFO_SUBMIT = 'btn_info_submit',

  BTN_PUBLIC_PROFILE = 'btn_public_profile',
  BTN_BASIC_INFO = 'btn_basic_info',
  BTN_SECURITY = 'btn_security',
  BTN_NOTIFICATION_PREFERENCE = 'btn_notification_preference',
  BTN_PROFILE_PIC_CHANGE = 'btn_profile_pic_change',
  BTN_PROFILE_VIDEO_UPLOAD = 'btn_profile_video_upload',
  BTN_PROFILE_VIDEO_CHANGE = 'btn_profile_video_change',
  BTN_PROFILE_VIDEO_DELETE = 'btn_profile_video_delete',
  BTN_CANCEL = 'btn_cancel',
  BTN_UPDATE = 'btn_update',
  INPUT_WEBSITE = 'input_website',
  INPUT_CALENDLY = 'input_calendly',
  INPUT_COOL_FACTOR = 'input_cool_factor',
  INPUT_USER_NAME = 'input_user_name',

  INPUT_PSWD_CURRENT = 'input_pswd_current',

  BTN_INVITE = 'btn_invite',
  BTN_VIEW_INVOICE = 'btn_view_invoice',
  BTN_BUY_1 = 'btn_buy_1',
  BTN_BUY_4 = 'btn_buy_4',
  BTN_BUY_20 = 'btn_buy_20',
  BTN_CREDIT_DEC = 'btn_credit_dec',
  BTN_CREDIT_INC = 'btn_credit_inc',
  BTN_PAY = 'btn_pay',
  BTN_FINISH = 'btn_finish',
  INPUT_CC = 'input_cc',
  INPUT_CC_EXP = 'input_cc_exp',
  INPUT_CC_CVV = 'input_cc_cvv',

  BTN_COPY_LINK = 'btn_copy_link',
  BTN_JOB_COPY_LINK = 'btn_job_copy_link',

  VIDEO_PLAY = 'video_play',
  VIDEO_PAUSE = 'video_pause',
  VIDEO_REPLAY = 'video_replay',
  VIDEO_SCRUB = 'video_scrub',
  VIDEO_SEEK_TO = 'video_seek_to',

  BTN_VIDEO_INFO = 'btn_video_info',
  BTN_DETAIL_PROFILE = 'btn_detail_profile',
  BTN_DETAIL_COMMENTS = 'btn_detail_comments',
  INPUT_PRIVATE_NOTES = 'input_private_notes',

  // CAMPAIGN EVENTS
  BTN_DUPLICATE_JOB = 'btn_duplicate_job',
  BTN_EDIT_JOB = 'btn_edit_job',
  BTN_DELETE_JOB = 'btn_delete_job',
  BTN_PAUSE_JOB = 'btn_pause_job',
  BTN_UNPAUSE_JOB = 'btn_unpause_job',
  BTN_ARCHIVE_JOB = 'btn_archive_job',

  BTN_CONFIRM_DELETE_JOB = 'btn_confirm_delete_job',
  BTN_CANCEL_DELETE_JOB = 'btn_cancel_delete_job',
  BTN_CONFIRM_PAUSE_JOB = 'btn_confirm_pause_job',
  BTN_CANCEL_PAUSE_JOB = 'btn_cancel_pause_job',
  BTN_CONFIRM_ARCHIVE_JOB = 'btn_confirm_archive_job',
  BTN_CANCEL_ARCHIVE_JOB = 'btn_cancel_archive_job',

  BTN_CREATE_JOB = 'btn_create_job',
  BTN_JOB_DETAILS = 'btn_job_details',
  CAMPAIGN_BTN_JOB_SELECT = 'btn_jobs_select',
  CAMPAIGN_BTN_JOB_EDIT = 'btn_jobs_edit',
  BTN_TAB_PUBLISHED = 'btn_tab_published',
  BTN_TAB_DRAFT = 'btn_tab_draft',
  BTN_TAB_ARCHIVED = 'btn_tab_archived',
  BTN_CREATE_A_LISTING = 'btn_create_a_listing',
  CAMPAIGN_BTN_JOBS_COPY_URL = 'btn_jobs_copy_url',
  CAMPAIGN_BTN_VIDEO_INFO = 'btn_video_info',
  CAMPAIGN_BTN_VIDEO_SHARE = 'btn_video_share',
  CAMPAIGN_BTN_VIDEO_SOFTSKILLS = 'btn_video_softskills',
  CAMPAIGN_BTN_VIDEO_INFO_SOFTSKILLS = 'btn_video_info_softskills',
  CAMPAIGN_BTN_VIDEO_INFO_EXPERIENCE = 'btn_video_info_experience',
  CAMPAIGN_BTN_VIDEO_INFO_EDUCATION = 'btn_video_info_education',
  CAMPAIGN_SELECT_JOBS_VIEW = 'select_jobs_view',
  CAMPAIGN_BTN_SOFTSKILLS_FILTER = 'btn_softskills_filter',
  CHECKBOX_MOTIVATOR = 'chkbox_softskill_motivator',
  CHECKBOX_CORE = 'chkbox_softskill_core',
  BTN_SOFTSKILLS_DEFAULT = 'btn_softskills_default',
  BTN_SOFTSKILLS_CANCEL = 'btn_softskills_cancel',
  BTN_SOFTSKILLS_SUBMIT = 'btn_softskills_submit',
  CAMPAIGN_BTN_COMPANY_LOGO_UPLOAD = 'btn_company_logo_upload',
  CAMPAIGN_INPUT_COMPANY_NAME = 'input_company',
  CAMPAIGN_INPUT_COMPANY_URL = 'input_company_url',
  CAMPAIGN_COMPANY_VIDEO_CREATE = 'btn_company_video_create',
  CAMPAIGN_COMPANY_VIDEO_UPLOAD = 'btn_company_video_upload',
  CAMPAIGN_COMPANY_JOB_NEXT = 'btn_jobs_next',
  CAMPAIGN_COMPANY_JOB_CANCEL = 'btn_jobs_cancel',
  CAMPAIGN_COMPANY_JOB_PREVIEW = 'btn_jobs_preview',
  CAMPAIGN_INPUT_JOB_NAME = 'input_jobs_name',
  CAMPAIGN_INPUT_JOB_TITLE = 'input_jobs_title',
  CAMPAIGN_INPUT_JOB_TRADE = 'input_jobs_trade',
  SELECT_JOB_SALARY_RANGE = 'select_jobs_salary_range',
  SELECT_JOB_SALARY_ATM = 'select_job_salary_amt',
  SELECT_JOB_SALARY_RATE = 'select_jobs_salary_rate',
  CAMPAIGN_INPUT_JOB_LOCATION = 'input_jobs_location',
  CAMPAIGN_CHECKBOX_JOB_REMOTE = 'chkbox_jobs_remote',
  CAMPAIGN_BTN_HM_VIDEO_CREATE = 'btn_hm_video_create',
  CAMPAIGN_BTN_HM_VIDEO_UPLOAD = 'btn_hm_video_upload',
  CAMPAIGN_BTN_HM_VIDEO_PROFILE = 'btn_hm_video_profile',
  CAMPAIGN_SELECT_JOB_QUESTION = 'select_jobs_question',
  CAMPAIGN_CHECKBOX_JOB_RESUME = 'chkbox_jobs_resume',
  CAMPAIGN_CHECKBOX_JOB_LINKEDIN = 'chkbox_jobs_linkedin',
  CAMPAIGN_CHECKBOX_JOB_ZIP = 'chkbox_jobs_zip',
  CAMPAIGN_INPUT_JOB_DESCRIPTION = 'input_jobs_description',
  CAMPAIGN_BTN_JOB_GEN_SUMMARY = 'btn_jobs_gen_summary',
  CAMPAIGN_INPUT_JOB_SUMMARY = 'input_jobs_summary',
  CAMPAIGN_INPUT_JOB_ATTACH_FILE = 'btn_jobs_attach_file',
  CAMPAIGN_INPUT_JOB_MARKETPLACE = 'chkbox_jobs_marketplace',
  CAMPAIGN_COMPANY_JOB_SUBMIT = 'btn_jobs_submit',
  CAMPAIGN_SELECT_JOBS_SORT = 'select_jobs_sort',
  CAMPAIGN_JOBS_DELETE = 'btn_jobs_delete',
  CAMPAIGN_JOBS_DETAIL = 'btn_jobs_detail',
  CAMPAIGN_INPUT_JOBS_SEARCH = 'input_jobs_search',
  BTN_NAV_NOTIFICATIONS = 'btn_nav_notifications',

  RECORDING_BTN_REC_SAMPLES = 'btn_rec_samples',
  RECORDING_BTN_REC_TIPS = 'btn_rec_tips',
  RECORDING_BTN_REC_BKGD_IMAGE = 'btn_rec_bkgd_image',
  RECORDING_BTN_REC_TELEPROMPTER = 'btn_rec_teleprompter',
  RECORDING_BTN_REC_UPLOAD = 'btn_rec_upload',

  BTN_VIBE_TALENT = 'btn_vibe_talent',

  // job_detail
  BTN_TALENT_DETAILS = 'btn_talent_details',
  BTN_TALENT_MESSAGE = 'btn_talent_message',
  BTN_TALENT_LIKE = 'btn_talent_like',
  BTN_TALENT_INVITE = 'btn_talent_invite',

  // talent details
  BTN_TALENT_DETAILS_TAB_DETAILS = 'btn_tab_details',
  BTN_TALENT_DETAILS_TAB_MESSAGES = 'btn_tab_messages',
  BTN_TALENT_DETAILS_VVC_PLAY = 'btn_vvc_play',
  BTN_TALENT_DETAILS_VVC_PAUSED = 'btn_vvc_paused',
  BTN_TALENT_DETAILS_VVC_SCRUB = 'slider_vvc_scrub',
  BTN_TALENT_DETAILS_RESUME = 'btn_resume',
  BTN_TALENT_DETAILS_INPUT_NOTES = 'input_notes',
  BTN_TALENT_DETAILS_INPUT_MESSAGE = 'input_message',
  BTN_TALENT_DETAILS_OPEN_EMOJI_PICKER = 'btn_open_emoji_picker',
  BTN_TALENT_DETAILS_INPUT_MESSAGE_ATTACH_FILE = 'btn_input_message_attach_file',
  BTN_TALENT_DETAILS_SEND_MESSAGE = 'btn_send_message',

  // side nav
  BTN_NAV_MY_JOBS = 'btn_nav_my_jobs',
  BTN_NAV_VIBE_TALENT = 'btn_nav_vibe_talent',
  BTN_NAV_MARKET_PLACE = 'btn_nav_market_place',
  BTN_NAV_MY_CONNECTIONS = 'btn_nav_my_connections',
  BTN_NAV_MESSAGES = 'btn_nav_messages',
  BTN_NAV_MY_VIDEOS = 'btn_nav_my_videos',
  BTN_NAV_SETTINGS = 'btn_nav_settings',
  BTN_NAV_MY_VIDEOS_PUBLISHED = 'btn_nav_my_videos_published',
  BTN_NAV_MY_VIDEOS_ARCHIVE = 'btn_nav_my_videos_archive',
  BTN_NAV_COMMUNITY = 'btn_nav_community',
  BTN_NAV_COMMUNITIES = 'btn_nav_communities',

  // video
  BTN_VIDEO_RENAME = 'btn_video_rename',
  BTN_VIDEO_REPLACE = 'btn_video_replace',
  BTN_VIDEO_PUBLISH = 'btn_video_publish',
  BTN_VIDEO_DETAILS = 'btn_video_details',

  // claim jobs
  BTN_CLAIM_JOB = 'btn_claim_job',
  BTN_CLAIM_JOBS_DETAILS = 'btn_claim_job_details',

  // create job
  BTN_RECORD_VVC = 'btn_rec_vvc',
  BTN_UPLOAD_VVC = 'btn_upload_vvc',
  BTN_RECORD_START = 'btn_rec_start',
  BTN_RECORD_STOP = 'btn_rec_stop',
  BTN_RE_RECORD = 'btn_re_record',
  BTN_VVC_DOWNLOAD = 'btn_vvc_download',
  BTN_VVC_NEXT = 'btn_vvc_next',
  BTN_VIEW_SAMPLES = 'btn_view_samples',
  BTN_VIEW_MORE = 'btn_view_more',
  BTN_NOTES = 'btn_notes',
  INPUT_JOB_TITLE = 'input_job_title',
  INPUT_SALARY_MIN = 'input_salary_min',
  INPUT_SALARY_MAX = 'input_salary_max',
  INPUT_SALARY_PERIOD = 'input_salary_period',
  INPUT_WORKPLACE_TYPE = 'input_workplace_type',
  INPUT_LOCATION = 'input_location',
  INPUT_EXPIRATION_DATE = 'input_expiration',
  RADIO_REQUIRE_RESUME = 'radio_require_resume',
  RADIO_TRADES = 'radio_trades',
  RADIO_UPLOAD_ATTACHMENT = 'radio_upload_job_descrip',
  RADIO_INPUT_JOB_DESCRIPTION = 'radio_input_job_descrip',
  INPUT_JOB_DESCRIPTION = 'input_job_descrip',
  BTN_SAVE_DRAFT = 'btn_save_draft',
  BTN_PREVIEW = 'btn_preview',
  BTN_NEXT = 'btn_next',
  CHECKBOX_MARKETPLACE = 'checkbox_marketplace',
  INPUT_PERSONAL_PHONE = 'input_personal_phone',
  INPUT_AGENCY_PHONE = 'input_agency_phone',
  INPUT_LINKEDIN = 'input_linkedin',
  BTN_CONFIRM = 'btn_confirm',

  // top nav
  INPUT_NAV_SEARCH_MESSAGES = 'input_nav_search_messages',
  INPUT_NAV_SEARCH_APPLICANTS = 'input_nav_search_applicants',
  INPUT_NAV_SEARCH_PEOPLE = 'input_nav_search_people',
  INPUT_NAV_SEARCH_VIDEOS = 'input_nav_search_videos',
  INPUT_NAV_SEARCH_CLAIM_JOBS = 'input_nav_search_claim_jobs',

  TALENT_VIDEO_HOVER_IN = 'talent_video_hover_in',
  TALENT_VIDEO_HOVER_OUT = 'talent_video_hover_out',

  BTN_NEXT_TALENT = 'next_talent',
  BTN_PREVIOUS_TALENT = 'previous_talent',

  CHECK_JOB_TO_INVITE = 'check_job_to_invite',
  UNCHECK_JOB_TO_INVITE = 'uncheck_job_to_invite',

  BTN_SETTING_EDIT_AVATAR = 'btn_setting_edit_avatar',
  BTN_SETTING_EDIT_PHONE_AND_LINKEDIN = 'btn_setting_edit_phone_and_linkedin',
  BTN_SETTING_SELECT_AVATAR = 'btn_setting_select_avatar',
  INPUT_SETTING_FIRST_NAME = 'input_setting_first_name',
  INPUT_SETTING_LAST_NAME = 'input_setting_last_name',
  INPUT_SETTING_ROLE = 'input_setting_role',
  INPUT_SETTING_CANCEL_EDIT_AVATAR = 'input_setting_cancel_edit_avatar',
  INPUT_SETTING_SAVE_EDIT_AVATAR = 'input_setting_save_edit_avatar',
  INPUT_SETTING_CANCEL_EDIT_ROLES = 'input_setting_cancel_edit_roles',
  INPUT_SETTING_SAVE_EDIT_ROLES = 'input_setting_save_edit_roles',
  INPUT_SETTING_LINKEDIN = 'input_setting_linkedin',
  INPUT_SETTING_PHONE = 'input_setting_phone',
  INPUT_SETTING_CANCEL_EDIT_PHONE_AND_LINKEDIN = 'input_setting_cancel_edit_phone_and_linkedin',
  INPUT_SETTING_SAVE_EDIT_PHONE_AND_LINKEDIN = 'input_setting_save_edit_phone_and_linkedin',
  BUTTON_CHANGE_COMPANY_LOGO = 'btn_change_company_logo'
}
